import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button,
  Checkbox,
  DatePicker,
  DateRangePicker,
  Input,
  Pagination,
  Table,
  Tooltip,
  Whisper,
} from "rsuite";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import * as XLSX from "xlsx";
import { ApprovalVM } from "../../Models/ViewModels";
import {
  ApproveData,
  EditKra,
  GetApprovalDetails,
  RejectData,
} from "../../Services/KRAApprovalDB";
import { GetUserLoginID, GetUserRole } from "../../Services/UserSessionManager";
import { GetSubStateProcess } from "../../Services/WeightageDB";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import {
  CustomTableCell,
  EditCell,
  EditCellAccountDropdown,
  EditCellProcessDropdown,
  EditCellSubstateDropdown,
} from "../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { PageHeader } from "../../SharedComponents/PageHeader";
import {
  Dropdown,
  DropdownButton,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
const { Column, HeaderCell, Cell } = Table;

export const KraApprovalScreen = () => {
  const keyarr: Array<number> = [];
  const [checkedKeys, setCheckedKeys] = useState(keyarr);
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [checkDesig, setCheckDesig] = useState(GetUserRole());
  const [cachedKraData, setCachedKradData] = useState(new Array<ApprovalVM>());
  const [filteredKraData, setFilteredKraData] = useState(
    new Array<ApprovalVM>()
  );
  const [sortType, setSortType] = useState();
  const [sortColumn, setSortColumn] = useState();
  const [tableInfo, setTableInfo] = useState(new Array<ApprovalVM>());
  const [difference, setDifference] = useState();
  const [range, setRange] = useState();
  const [processNameForSubstate, setProcessNameforSubState] = useState("");
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [isLoading, setLoading] = useState(true); //let processNameForSubstate:string='';
  const [searching, setSearching] = useState(false);
  const [show, setShow] = useState(false);
  const [searchby, setSearchBy] = useState("Dropdown");
  const [searchby2, setSearchBy2] = useState("Dropdown");
  const [searchval, setSearchval] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let checked = false;
  let indeterminate = false;
  useEffect(() => {
    GetTableStats(loginid);
  }, []);

  const GetTableStats = (loginid: any) => {
    GetApprovalDetails(loginid).then((res) => {
      setCachedKradData(res.data);
      if (searching) {
        setFilteredKraData(
          res.data.filter((e: any) =>
            JSON.stringify(e).toLowerCase().includes(searchval.toLowerCase())
          )
        );
      } else setFilteredKraData(res.data);
      setLoading(false);
    });

    // setLoading(false)
  };
  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return filteredKraData.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  // const filterData = (event: any) => {
  //   setPage(1);
  //   let searchText = event.target.value;
  //   if (searchText) {
  //     console.log(searchText);
  //     if (searchby === "ID")
  //       setFilteredKraData(
  //         cachedKraData.filter((e) =>
  //           e.EmployeeID.toLowerCase().includes(searchText.toLowerCase())
  //         )
  //       );
  //     else if (searchby === "Name")
  //       setFilteredKraData(
  //         cachedKraData.filter((e) =>
  //           e.EmployeeName.toLowerCase().includes(searchText.toLowerCase())
  //         )
  //       );
  //     else if (searchby === "Designation")
  //       setFilteredKraData(
  //         cachedKraData.filter((e) =>
  //           e.Designation.toLowerCase().includes(searchText.toLowerCase())
  //         )
  //       );
  //     else if (searchby === "Account")
  //       setFilteredKraData(
  //         cachedKraData.filter((e) =>
  //           e.AccountName.toLowerCase().includes(searchText.toLowerCase())
  //         )
  //       );
  //     else if (searchby === "SubState")
  //       setFilteredKraData(
  //         cachedKraData.filter((e) =>
  //           e.SubStateName.toLowerCase().includes(searchText.toLowerCase())
  //         )
  //       );
  //     else if (searchby === "ApprovedBy")
  //       setFilteredKraData(
  //         cachedKraData.filter((e) =>
  //           e.ApprovedBy.toLowerCase().includes(searchText.toLowerCase())
  //         )
  //       );
  //     else if (searchby === "Status")
  //       setFilteredKraData(
  //         cachedKraData.filter((e) =>
  //           e.status.toLowerCase().includes(searchText.toLowerCase())
  //         )
  //       );
  //     else if (searchby === "Process")
  //       setFilteredKraData(
  //         cachedKraData.filter((e) =>
  //           e.ProcessName.toLowerCase().includes(searchText.toLowerCase())
  //         )
  //       );
  //     else if (searchby === "Dropdown")
  //       setFilteredKraData(
  //         cachedKraData.filter((e) =>
  //           JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
  //         )
  //       );
  //   } else setFilteredKraData([...cachedKraData]);
  // };

  const filterData = () => {
    setPage(1);
    var search1value = (document.getElementById("Search1") as HTMLInputElement)
      .value;
    var search2value = (document.getElementById("Search2") as HTMLInputElement)
      .value;

    setFilteredKraData(
      cachedKraData.filter(
        (e) =>
          includesSearchValue(e, searchby, search1value) &&
          includesSearchValue(e, searchby2, search2value)
      )
    );
  };
  const includesSearchValue = (
    e: ApprovalVM,
    searchBy: string,
    searchText: string
  ) => {
    console.log(searchBy + " " + searchText);
    switch (searchBy) {
      case "ID":
        return e.EmployeeID.toLowerCase().includes(searchText.toLowerCase());

      case "Name":
        return e.FullName.toLowerCase().includes(searchText.toLowerCase());

      case "Account":
        return e.AccountName.toLowerCase().includes(searchText.toLowerCase());
      case "SubState":
        return e.SubStateName.toLowerCase().includes(searchText.toLowerCase());

      case "Process":
        return e.ProcessName.toLowerCase().includes(searchText.toLowerCase());

      case "Designation":
        return e.Designation.toLowerCase().includes(searchText.toLowerCase());

      case "ApprovedBy":
        return e.ApprovedBy.toLowerCase().includes(searchText.toLowerCase());

      case "Status":
        return e.status.toLowerCase().includes(searchText.toLowerCase());

      default:
        return JSON.stringify(e)
          .toLowerCase()
          .includes(searchText.toLowerCase());
    }
  };
  if (checkedKeys.length > 0 && checkedKeys.length <= filteredKraData.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (
    checkedKeys.length > 0 &&
    checkedKeys.length < filteredKraData.length
  ) {
    indeterminate = true;
  }
  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const tableDataFeed = filteredKraData.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });
  const handleCheckAll = (value: any, checked: any) => {
    const filteredData = checked
      ? filteredKraData.filter((item) => item.status === "Pending")
      : [];
    const keys = checked ? filteredData.map((item) => item.ID) : [];

    setCheckedKeys(keys);
  };
  const handleCheck = (value: any, checked: any) => {
    const keys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value);

    setCheckedKeys(keys);
  };

  const CheckCell = ({
    rowData,
    onChange,
    checkedKeys,
    dataKey,
    ...props
  }: any) => (
    <Cell
      className="border-bottom border-dark"
      {...props}
      style={{ padding: 0 }}
    >
      <div style={{ lineHeight: "30px" }}>
        {rowData.status === "Approved" ? (
          <Checkbox disabled value={rowData[dataKey]} inline />
        ) : (
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item: any) => item === rowData[dataKey])}
          />
        )}
      </div>
    </Cell>
  );

  const handleChange = (id: any, key: any, value: any) => {
    setProcessNameforSubState("");
    const nextData: any = Object.assign([], filteredKraData);
    nextData.find((item: any) => item.ID === id)[key] = value;
    if (key === "ProcessName")
      //processNameForSubstate=( nextData.find((item: any) => item.ID === id)[key])

      setProcessNameforSubState(
        nextData.find((item: any) => item.ID === id)[key]
      );

    setFilteredKraData(nextData);
  };

  const handleEditState = (id: any) => {
    const nextData = Object.assign([], filteredKraData);

    const activeItem: any = nextData.find((item: any) => item.ID === id);

    activeItem.status1 = activeItem.status1 ? null : "EDIT";

    setFilteredKraData(nextData);
  };

  const handleApproval = (checkedKeys: any, loginid: any) => {
    ApproveData(checkedKeys, loginid).then((res) => {
      if (res.data == 1) {
        toast.success("Approved successfully");
        GetTableStats(loginid);
      } else toast.error("Failed to Approve!");
    });
  };

  const handleReject = (id: any, loginid: any) => {
    RejectData(id, loginid).then((res) => {
      if (res.data == 1) {
        toast.info("Rejected successfully");
        GetTableStats(loginid);
      } else toast.error("Failed to Rejected!");
    });
  };

  const handleChange1 = (e: any) => {
    setDifference(e.split("-").reverse().join("/"));
  };
  const handleRange1 = (e: any) => {
    setRange(e.split("-").reverse().join("/"));
  };
  const handeleEditRow = (
    rowData: ApprovalVM,
    loginid: any,
    checkDesig: any
  ) => {
    EditKra(rowData, loginid, checkDesig).then((res) => {
      if (res.data === "Success") {
        toast.info("Updated successfully!");
        GetTableStats(loginid);
      } else toast.error("Failed to Update!");
    });
  };

  const ActionCell = ({ rowData, dataKey, onClick, ...props }: any) => {
    return (
      <Cell className="border-bottom border-dark" {...props}>
        {rowData.status1 === "EDIT" ? (
          <i
            className="bi bi-check2-circle text-success fs-5 ms-4"
            style={{ cursor: "pointer" }}
            title="Save"
            onClick={() => {
              handeleEditRow(rowData, loginid, checkDesig);
              onClick && onClick(rowData.ID);
            }}
          ></i>
        ) : rowData.status === "Approved" ? (
          <i
            className="bi bi-hand-thumbs-down-fill text-danger ms-4"
            style={{ cursor: "pointer" }}
            title="Reject"
            onClick={() => handleReject(rowData.ID, loginid)}
          ></i>
        ) : rowData.status === "Rejected" ? (
          <i
            className="bi bi-hand-thumbs-up-fill text-success ms-4"
            style={{ cursor: "pointer" }}
            title="Approve"
            onClick={() => {
              handleApproval(rowData.ID, loginid);
            }}
          ></i>
        ) : (
          <div className="d-flex flex gap-2">
            <i
              className="bi bi-pencil-fill text-warning"
              style={{ cursor: "pointer" }}
              title="Edit"
              onClick={() => {
                onClick && onClick(rowData.ID);
              }}
            ></i>
            <i
              className="bi bi-hand-thumbs-up-fill text-success"
              style={{ cursor: "pointer" }}
              title="Approve"
              onClick={() => {
                handleApproval(rowData.ID, loginid);
              }}
            ></i>
            <i
              className="bi bi-hand-thumbs-down-fill text-danger"
              style={{ cursor: "pointer" }}
              title="Reject"
              onClick={() => handleReject(rowData.ID, loginid)}
            ></i>
          </div>
        )}
      </Cell>
    );
  };

  const handleGenrateReport = (filteredKraData: any) => {
    const newData = filteredKraData.filter((e: any) => {
      if (e.status === "Approved") return e;
    });
    const worksheet = XLSX.utils.json_to_sheet(newData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "data");
    XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, "Data.xlsx");
  };

  const handledate = (value: any) => {
    var startDate = value[0].setHours(0, 0, 0, 0);
    var endDate = value[1].setHours(0, 0, 0, 0);

    var res = cachedKraData.filter((e) => {
      var date = new Date(e.SubmittedOn);
      return date >= startDate && date <= endDate;
    });

    setFilteredKraData(res);
  };

  const SearchBy = (value: any) => {
    setSearchBy(value);
  };
  const SearchBy2 = (value: any) => {
    setSearchBy2(value);
  };
  return (
    <div>
      <div className="row ">
        <div className="col-md-2">
          <PageHeader title="Productivity Approval" backPage="">
            <></>
          </PageHeader>
        </div>
        <div className="col-md-10">
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <InputGroup className="mb-3">
                    <DropdownButton
                      variant="outline-secondary"
                      title={searchby}
                      id="input-group-dropdown-1"
                    >
                      <Dropdown.Item href="#" onClick={() => SearchBy("ID")}>
                        ID
                      </Dropdown.Item>
                      <Dropdown.Item href="#" onClick={() => SearchBy("Name")}>
                        Name
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy("Designation")}
                      >
                        Designation
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy("Account")}
                      >
                        Account
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy("Process")}
                      >
                        Process
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy("SubState")}
                      >
                        SubState
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy("ApprovedBy")}
                      >
                        Approved By
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy("Status")}
                      >
                        Status
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy("Dropdown")}
                      >
                        Default
                      </Dropdown.Item>
                    </DropdownButton>
                    <Form.Control
                      aria-label="Text input with dropdown button"
                      onChange={(event) => filterData()}
                      placeholder="Search..."
                      id="Search1"
                    />
                  </InputGroup>
                </div>
                <div className="col-md-6">
                  <InputGroup className="mb-3">
                    <DropdownButton
                      variant="outline-secondary"
                      title={searchby2}
                      id="input-group-dropdown-1"
                    >
                      <Dropdown.Item href="#" onClick={() => SearchBy2("ID")}>
                        ID
                      </Dropdown.Item>
                      <Dropdown.Item href="#" onClick={() => SearchBy2("Name")}>
                        Name
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy2("Designation")}
                      >
                        Designation
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy2("Account")}
                      >
                        Account
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy2("Process")}
                      >
                        Process
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy2("SubState")}
                      >
                        SubState
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy2("ApprovedBy")}
                      >
                        Approved By
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy2("Status")}
                      >
                        Status
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => SearchBy2("Dropdown")}
                      >
                        Default
                      </Dropdown.Item>
                    </DropdownButton>
                    <Form.Control
                      aria-label="Text input with dropdown button"
                      onChange={(event) => filterData()}
                      placeholder="Search..."
                      id="Search2"
                    />
                  </InputGroup>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <DateRangePicker
                placeholder="Select Date Range"
                onOk={(value: [Date, Date]) => handledate(value)}
                format="yyy-MM-dd"
              />
            </div>
            <div className="col-md-2">
              <Button
                type="button"
                className="d-flex justify-content-center"
                appearance="primary"
                onClick={() => handleGenrateReport(filteredKraData)}
              >
                Approved Report
              </Button>
            </div>
            <div className="col-md-1">
              <div className="d-flex flex-column">
                <i
                  className="bi bi-hand-thumbs-up-fill text-success"
                  style={{ fontSize: "25px", cursor: "pointer" }}
                  title="Approve Selected"
                  onClick={() => {
                    handleApproval(checkedKeys, loginid);
                  }}
                ></i>
                <div style={{ fontSize: 10 }}>Bulk Approval</div>
              </div>
            </div>
            <div className="col-md-1">
              {searching == true ? (
                <button
                  id="color"
                  onClick={() => handleDownloadAsExcel(tableDataFeed)}
                >
                  <BootstrapIcon
                    bootStrapIconName={"file-earmark-arrow-down-fill"}
                    size={30}
                    cssClasses={"pe-2"}
                  />{" "}
                </button>
              ) : (
                <button
                  id="color"
                  onClick={() => handleDownloadAsExcel(cachedKraData)}
                >
                  <BootstrapIcon
                    bootStrapIconName={"file-earmark-arrow-down-fill"}
                    size={30}
                    cssClasses={"pe-2"}
                  />{" "}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-between">
        <div className="d-flex flex gap-4">
          <div>
            <BootstrapIcon
              bootStrapIconName="clock-fill text-warning"
              size={15}
              cssClasses="me-1"
            ></BootstrapIcon>
            Pending
          </div>
          <div>
            <BootstrapIcon
              bootStrapIconName="check-circle-fill text-success"
              size={15}
              cssClasses="me-1"
            ></BootstrapIcon>
            Approved
          </div>
          <div>
            <BootstrapIcon
              bootStrapIconName="x-circle-fill text-danger"
              size={15}
              cssClasses="me-1"
            ></BootstrapIcon>
            Rejected
          </div>
        </div>
        <div className="d-flex flex gap-4">
          <div>
            <BootstrapIcon
              bootStrapIconName="hand-thumbs-up-fill text-success"
              size={15}
              cssClasses="me-1"
            ></BootstrapIcon>
            Approve
          </div>
          <div>
            <BootstrapIcon
              bootStrapIconName="hand-thumbs-down-fill text-danger"
              size={15}
              cssClasses="me-1"
            ></BootstrapIcon>
            Reject
          </div>
        </div>
      </div>
      <Table
        height={450}
        data={tableDataFeed}
        loading={isLoading}
        onSortColumn={handleSortColumn}
        sortColumn={sortColumn}
        sortType={sortType}
        id="table"
        bordered={true}
        cellBordered={true}
        className="border border-dark mt-2"
        autoHeight={true}
        rowHeight={40}
        headerHeight={40}
      >
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "30px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>

          <CheckCell
            dataKey="ID"
            checkedKeys={checkedKeys}
            onChange={handleCheck}
          />
        </Column>
        <Column width={30} align="center" fixed>
          <CustomTableHeaderCell></CustomTableHeaderCell>
          <CustomTableCell>
            {(rowData: ApprovalVM) => {
              if (rowData.status === "Pending") {
                return (
                  <BootstrapIcon
                    bootStrapIconName="clock-fill text-warning"
                    size={15}
                    cssClasses="me-1"
                  ></BootstrapIcon>
                );
              } else if (rowData.status === "Approved") {
                return (
                  <BootstrapIcon
                    bootStrapIconName="check-circle-fill text-success"
                    size={15}
                    cssClasses="me-1"
                  ></BootstrapIcon>
                );
              } else {
                return (
                  <BootstrapIcon
                    bootStrapIconName="x-circle-fill text-danger"
                    size={15}
                    cssClasses="me-1"
                  ></BootstrapIcon>
                );
              }
            }}
          </CustomTableCell>
        </Column>

        <Column width={70} align="center" fixed>
          <CustomTableHeaderCell placement={"Emp ID"}>
            Emp ID
          </CustomTableHeaderCell>
          <CustomTableCell dataKey="EmployeeOfficeBadgeId" />
        </Column>
        <Column width={170} align="center" fixed sortable>
          <CustomTableHeaderCell placement={"EmployeeName"}>
            EmployeeName
          </CustomTableHeaderCell>
          <CustomTableCell dataKey="FullName" />
        </Column>
        <Column width={170} align="center" sortable>
          <CustomTableHeaderCell placement={"Designation"}>
            Designation
          </CustomTableHeaderCell>
          <CustomTableCell dataKey="Designation" />
        </Column>
        <Column width={80} align="center">
          <CustomTableHeaderCell placement={"Date"}>Date</CustomTableHeaderCell>
          <CustomTableCell>
            {(rowData: any) => {
              return rowData.SubmittedOn.substring(
                0,
                rowData.SubmittedOn.indexOf("T")
              );
            }}
          </CustomTableCell>
        </Column>
        <Column width={120} align="center" sortable>
          <CustomTableHeaderCell placement={"Account"}>
            Account
          </CustomTableHeaderCell>
          <EditCellAccountDropdown
            dataKey="AccountName"
            onChange={handleChange}
          />
        </Column>
        <Column width={100} align="center" sortable>
          <CustomTableHeaderCell placement={"Process"}>
            Process
          </CustomTableHeaderCell>
          <EditCellProcessDropdown
            dataKey="ProcessName"
            onChange={handleChange}
          />
        </Column>
        <Column width={170} align="center" sortable>
          <CustomTableHeaderCell placement={"SubState"}>
            {" "}
            SubState
          </CustomTableHeaderCell>
          <EditCellSubstateDropdown
            dataKey="SubStateName"
            processName={processNameForSubstate}
            onChange={handleChange}
          />
        </Column>
        <Column width={120} align="center" sortable>
          <CustomTableHeaderCell placement={"Production Target"}>
            Production Target
          </CustomTableHeaderCell>
          <CustomTableCell dataKey="Target" />
        </Column>
        <Column width={120} align="center" sortable>
          <CustomTableHeaderCell placement={"Production Count"}>
            Production Count
          </CustomTableHeaderCell>
          <EditCell dataKey="ProductionCount" onChange={handleChange} />
        </Column>
        <Column width={90} align="center" sortable>
          <CustomTableHeaderCell placement={"Production %"}>
            Production %
          </CustomTableHeaderCell>
          <CustomTableCell dataKey="ProductionPercent" />
        </Column>
        <Column width={270} align="center" sortable>
          <CustomTableHeaderCell placement={"Remarks"}>
            Remarks
          </CustomTableHeaderCell>
          <EditCell dataKey="Remarks" onChange={handleChange} />
        </Column>
        <Column width={100} align="left">
          <CustomTableHeaderCell placement={"Approved By"}>
            Approved By
          </CustomTableHeaderCell>
          <CustomTableCell dataKey="ApprovedBy" />
        </Column>
        <Column width={100} align="left">
          <CustomTableHeaderCell placement={"Approved On"}>
            Approved On
          </CustomTableHeaderCell>
          <CustomTableCell>
            {(rowData: any) => {
              if (rowData.ApprovedOn != null) {
                return rowData.ApprovedOn.substring(
                  0,
                  rowData.ApprovedOn.indexOf("T")
                );
              } else return rowData.ApprovedOn;
            }}
          </CustomTableCell>
        </Column>
        <Column width={120} align="left" fixed="right" sortable>
          <CustomTableHeaderCell placement={"Approval Status"}>
            Approval Status
          </CustomTableHeaderCell>
          <CustomTableCell dataKey="status" />
        </Column>
        <Column width={70} fixed="right">
          <CustomTableHeaderCell></CustomTableHeaderCell>
          <ActionCell dataKey="ID" onClick={handleEditState} />
        </Column>
      </Table>
      {filteredKraData && (
        <div style={{ padding: 20 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="md"
            layout={["total", "-", "limit", "|", "pager", "skip"]}
            total={filteredKraData.length}
            limitOptions={[10, 15, 20, 25, 30]}
            limit={limit}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
      )}
    </div>
  );
};
